import { NavLink, Link } from 'react-router-dom';
import '../../componentsUpdated/Dashboard/Sidebar/sidebar.scss';
import { Icon } from '@iconify/react';

export const Sidebar = ({ mobile, navigationLinks, setMobile }) => {
  const handleNavLinkClick = () => {
    setMobile(!mobile);
  };

  return (
    <>
      {mobile && (
        <button
          className="bg-black opacity-50 fixed top-0 left-0 w-screen h-screen z-50 !rounded-none"
          onClick={() => handleNavLinkClick()}
        ></button>
      )}
      <div
        className={`side_nav z-[55] flex justify-between flex-col homeSidebarIn ${
          mobile && 'homeSidebarOut'
        } `}
      >
        <div className="h-full">
          <div className="nav_side flex items-center justify-between border-b border-[#E7E7E9]">
            <Link to={'/dashboard'} onClick={handleNavLinkClick}>
              <div className="w-40">
                <img
                  src="/images/new_logo.jpg"
                  style={{ mixBlendMode: 'darken' }}
                  alt="logo"
                />
              </div>
            </Link>
            <div className="block xl:hidden close_position">
              <Icon icon="gg:close-o" onClick={() => setMobile(false)} />
            </div>
          </div>
          <ul className="navigation-links">
            {navigationLinks.map((item) =>
              item.heading === '' ? (
                <NavLink
                  activeClassName="activeClass"
                  to={item.url || '/'}
                  key={item.id}
                  exact
                  onClick={() => handleNavLinkClick()}
                  className="text-black !text-xl !ml-0 bg-transparent"
                  style={{ position: 'relative' }}
                >
                  <li>
                    <span>{item.icon}</span>
                    <span>{item.title}</span>
                  </li>
                </NavLink>
              ) : (
                <NavLink
                  activeClassName="activeClass"
                  to={item.url || '/'}
                  key={item.id}
                  exact
                  onClick={() => handleNavLinkClick()}
                  className="text-black !text-xl !ml-0 bg-transparent"
                  style={{ position: 'relative' }}
                >
                  <li>
                    <span>{item.icon}</span>
                    <span>{item.title}</span>
                  </li>
                </NavLink>
              )
            )}
          </ul>
        </div>
      </div>
    </>
  );
};
